/* Así funciona · Tendedero de Pared Plegable (2190858)
   Todo sale de las fotos reales (piezas en tiendas/nayhogar/funciona/tendedero-de-pared-plegable/hacer.py): la
   clienta jala la punta del brazo y el tendedero REAL se abre desde la pared: cada tramo (barra con sus 6 ganchos,
   recortado de la foto y llevado a su plano vertical) gira sobre sus ejes reales (la bisagra de la placa y los
   pasadores de cada unión) con la cámara real de la foto (camara.py, error 1 px). Recogido = los 3 tramos paralelos
   a la pared (la dirección la marca la placa), uno delante del otro. Abierto del todo queda EXACTO como la foto, y
   "Cuelga la ropa" pasa a la foto real del MISMO tendedero en la MISMA pose con camisas (galeria_1 alineada).
   Ficha: se abre y se recoge contra la pared, espacios para ganchos, ideal para patios y balcones pequeños. */
NHF.escena('tendedero-de-pared-plegable', function (E) {
  const D = /*DATOS*/{"ox":240,"oy":220,"fondo":"fn-tendedero-de-pared-plegable-fondo.webp","sombra":{"src":"fn-tendedero-de-pared-plegable-sombra.webp","caja":[150,1300,1280,230]},"bisagra":{"src":"fn-tendedero-de-pared-plegable-bisagra.webp","caja":[1257,233,89,233]},"tramo1":{"src":"fn-tendedero-de-pared-plegable-tramo1.webp","w":1185,"h":444,"s0":-0.87,"s1":7.0319},"tramo2":{"src":"fn-tendedero-de-pared-plegable-tramo2.webp","w":1292,"h":444,"s0":-1.2,"s1":7.4119},"tramo3":{"src":"fn-tendedero-de-pared-plegable-tramo3.webp","w":1509,"h":444,"s0":-0.9,"s1":9.1619},"foto":"fn-tendedero-de-pared-plegable-foto.webp","ropa":"fn-tendedero-de-pared-plegable-ropa.webp","cam":{"P":[8952.7174748,-410.3744858,-559.4123567,77512.1300728,-213.7235909,-8438.6535839,2838.4632051,30553.9205942,0.0546695,-0.3160326,-0.9471719,59.5930776]},"cadena":{"psi":[140.352,41.759,140.373],"L":6.2619,"l1":[-0.4184,0.3442],"l2":[-0.3177,0.2908],"pared":43.6,"ytop":2.35,"ybot":-0.61,"punta":[7.49,1.4]}}/*FIN*/;
  // el lienzo es la foto (1600) más OX px de la misma piedra a la izquierda (al recogerse, la punta barre hacia allá)
  // y OY px arriba (en el celular, aire para los botones de la escena)
  const OX = D.ox, OY = D.oy;
  const S = E.lienzo({ w: 1600 + OX, h: 1600 + OY, vista: [110, 25 + OY, 1600, 1480], vistaMovil: [110, 40, 1600, 1680] });
  E.titulo('Ábrelo y [recógelo].', 'Jala la punta del brazo: se abre desde la pared. Cuando termines, lo recoges y no estorba.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (todas de las fotos reales) ---------- */
  S.img(D.fondo, null, { z: 1, alt: 'Tendedero de pared negro de 3 tramos con ganchos' });
  const SO = D.sombra, sc = [D.sombra.caja[0] + OX, D.sombra.caja[1] + OY, D.sombra.caja[2], D.sombra.caja[3]];
  const sombra = S.img(SO.src, sc, { z: 2, pivote: [OX + 1300, OY + 1415] });   // se encoge hacia el lado de la placa
  function tex(T, z) { const i = S.img(T.src, [0, 0, T.w, T.h], { z }); i.style.transformOrigin = '0 0'; i.style.willChange = 'transform'; return i; }
  const capas = [tex(D.tramo1, 5), tex(D.tramo2, 7), tex(D.tramo3, 8)];
  const bc = D.bisagra.caja;
  S.img(D.bisagra.src, [bc[0] + OX, bc[1] + OY, bc[2], bc[3]], { z: 6 });
  const foto = S.img(D.foto, [OX, OY, 1600, 1600], { z: 10, opacidad: 0 });
  const ropa = S.img(D.ropa, [OX, OY, 1600, 1600], { z: 11, opacidad: 0, alt: 'El tendedero abierto con camisas colgadas en sus ganchos' });
  foto.style.transition = 'opacity .35s ease'; ropa.style.transition = 'opacity .7s ease';
  E.cargar([D.fondo, D.tramo1.src, D.tramo2.src, D.tramo3.src, D.bisagra.src, SO.src]).then(() => { S.cargando(false); pintar(); });

  /* ---------- cámara real y cadena de tramos (unidad = separación entre ganchos) ---------- */
  const M = D.cam.P, C = D.cadena;
  const proy = p => { const w = M[8] * p[0] + M[9] * p[1] + M[10] * p[2] + M[11]; return [(M[0] * p[0] + M[1] * p[1] + M[2] * p[2] + M[3]) / w + OX, (M[4] * p[0] + M[5] * p[1] + M[6] * p[2] + M[7]) / w + OY]; };
  const u = a => { a *= Math.PI / 180; return [Math.cos(a), 0, Math.sin(a)]; };
  const suma = (a, b, k) => [a[0] + b[0] * (k == null ? 1 : k), a[1] + b[1] * (k == null ? 1 : k), a[2] + b[2] * (k == null ? 1 : k)];
  const girar = (v, d) => { const a = d * Math.PI / 180, c = Math.cos(a), s = Math.sin(a); return [v[0] * c - v[2] * s, v[1], v[0] * s + v[2] * c]; };
  // recogido: los 3 tramos paralelos a la pared (tramo 1 y 3 hacia la izquierda, tramo 2 de vuelta). Como se recoge
  // de verdad: primero el tramo 3 se dobla sobre el 2 (k 1 -> 0,45) y luego el brazo entero va a la pared girando el
  // tramo 1 en la bisagra de la placa (k 0,6 -> 0)
  const s01 = t => { t = Math.min(1, Math.max(0, t)); return t * t * (3 - 2 * t); };
  function pose(kk) {
    const a = s01(kk / 0.6), b = s01((kk - 0.45) / 0.55);
    const p1 = C.pared + 180 + (C.psi[0] - C.pared - 180) * a, p2 = C.pared + (C.psi[1] - C.pared) * a;
    return [p1, p2, p2 + 180 + ((C.psi[2] - C.psi[1]) - 180) * b];
  }
  function cadena(psi) {
    const d2 = psi[1] - C.psi[1];
    const B = [0, 0, 0], J1a = suma(B, u(psi[0]), C.L);
    const J1b = suma(J1a, girar([C.l1[0], 0, C.l1[1]], d2));      // los eslabones van con el tramo 2
    const J2a = suma(J1b, u(psi[1]), C.L);
    const J2b = suma(J2a, girar([C.l2[0], 0, C.l2[1]], d2));
    return [B, J1b, J2b];
  }
  const TR = [D.tramo1, D.tramo2, D.tramo3];
  let k = 0, meta = 0;
  function quad(i, S0, d) {
    const T = TR[i];
    return [suma(suma(S0, d, T.s0), [0, C.ytop, 0]), suma(suma(S0, d, T.s1), [0, C.ytop, 0]), suma(suma(S0, d, T.s1), [0, C.ybot, 0]), suma(suma(S0, d, T.s0), [0, C.ybot, 0])].map(proy);
  }
  function punta(kk) { const psi = pose(kk), ch = cadena(psi); return proy(suma(suma(ch[2], u(psi[2]), C.punta[0]), [0, C.punta[1], 0])); }
  function pintar() {
    const psi = pose(k), ch = cadena(psi);
    capas.forEach((c, i) => S.mapear(c, quad(i, ch[i], u(psi[i]))));
    // la sombra del piso se encoge hacia la pared al recogerlo
    // (pegado a la pared, su sombra en el piso queda más atrás: más arriba en la foto)
    sombra.style.transform = 'translateY(' + (-110 * (1 - k)).toFixed(1) + 'px) scale(' + (0.7 + 0.3 * k).toFixed(3) + ',' + (0.72 + 0.28 * k).toFixed(3) + ')';
    sombra.style.opacity = (0.6 + 0.4 * k).toFixed(3);
    // abierto del todo: la foto real exacta
    const exacto = k > 0.999;
    foto.style.transition = exacto ? 'opacity .35s ease' : 'none';
    foto.style.opacity = exacto ? 1 : 0;
    const p = punta(k), r = Math.max(80, 30 / Math.max(S.k, 0.05));
    zona.style.left = (p[0] - r) + 'px'; zona.style.top = (p[1] - r) + 'px'; zona.style.width = zona.style.height = (2 * r) + 'px';
    rango.poner(Math.round(k * 100));
  }

  /* ---------- panel ---------- */
  const ST = { abierto: false, ropa: false, colgada: false, recogidoDespues: false };
  E.pasos(['Jala la punta: se abre desde la pared', 'Cuelga la ropa en sus ganchos', 'Recógelo contra la pared']);
  E.paso(0);
  const rango = E.deslizador({ etiqueta: 'Brazo', min: 0, max: 100, valor: 0, formato: v => v < 2 ? 'Recogido' : v > 98 ? 'Abierto' : Math.round(v) + ' %' }, v => { irA(v / 100); });
  const bRopa = E.boton('Cuelga la ropa', () => colgar(), { icono: 'mano' });
  const bRecoger = E.boton('Recógelo', () => recoger());
  bRopa.disabled = true; bRecoger.hidden = true;
  E.nota('Se fija a la pared y se abre como un brazo, con espacios para ganchos. Ideal para patios y balcones pequeños.');

  /* ---------- movimiento con un poco de inercia hacia la meta ---------- */
  let corriendo = false, parada = null;
  // ms: movimiento completo a su ritmo (botón, toque); sin ms: sigue al dedo o al deslizador con un poco de inercia
  function irA(m, ms) {
    meta = E.clamp(m, 0, 1);
    if (ST.ropa && meta < 0.999) quitarRopa();
    if (E.reduce) { k = meta; pintar(); guia(); return; }
    if (ms) {
      if (parada) parada();
      const k0 = k;
      corriendo = true;
      parada = E.animar(ms, f => { k = k0 + (meta - k0) * f; pintar(); }, () => { parada = null; corriendo = false; k = meta; pintar(); guia(); }, E.suave);
      return;
    }
    if (parada) { parada(); parada = null; corriendo = false; }
    if (corriendo) return; corriendo = true;
    let ult = performance.now();
    const paso = t => {
      const dt = Math.min(0.05, (t - ult) / 1000); ult = t;
      const d = meta - k;
      k += d * Math.min(1, dt * 7);
      if (Math.abs(d) < 0.0015) k = meta;
      pintar();
      if (k !== meta) requestAnimationFrame(paso); else { corriendo = false; guia(); }
    };
    requestAnimationFrame(paso);
  }
  function guia() {
    if (k > 0.999 && !ST.abierto) { ST.abierto = true; E.sonido.clic(); E.vibrar(10); }
    if (k < 0.001 && ST.abierto) { ST.abierto = false; E.sonido.tono(190, 0.08, 0.05); E.vibrar(10); if (ST.colgada) ST.recogidoDespues = true; }
    bRopa.disabled = !(k > 0.999) || ST.ropa;
    bRecoger.hidden = k < 0.001;
    zona.classList.toggle('is-pista', k < 0.999 && !ST.colgada);
    if (ST.recogidoDespues) {
      E.paso(3); S.pista(null);
      E.listo('Abierto, cuelgas la ropa en sus ganchos; recogido, queda pegado a la pared y no estorba en el patio o el balcón.', reiniciar);
      return;
    }
    if (k > 0.999) { E.paso(ST.colgada ? 2 : 1); S.pista(ST.colgada ? 'Ahora recógelo contra la pared' : 'Cuelga la ropa', ST.colgada ? 'flechas' : 'toca'); return; }
    E.paso(ST.colgada ? 2 : 0);
    S.pista(ST.colgada ? 'Recógelo contra la pared' : 'Jala la punta del brazo', 'mano');
  }
  function colgar() {
    if (k < 0.999 || ST.ropa) return;
    ST.ropa = true; ST.colgada = true; ropa.style.opacity = 1; E.sonido.clic();
    bRopa.disabled = true; guia();
  }
  function quitarRopa() { ST.ropa = false; ropa.style.opacity = 0; }
  async function recoger() {
    if (ST.ropa) { quitarRopa(); await E.esperar(650); }
    irA(0, 2200);
  }
  function reiniciar() {
    E.noListo(); ST.colgada = false; ST.recogidoDespues = false; quitarRopa(); irA(0, 1600); E.paso(0);
  }

  /* ---------- jalar la punta real (la tapa del extremo) ---------- */
  const zona = S.toque([0, 0, 10, 10], { redonda: true, etiqueta: 'Punta del brazo: arrástrala para abrir o recoger el tendedero', z: 55 });
  zona.style.touchAction = 'none'; zona.style.cursor = 'grab';
  const CAM = []; for (let i = 0; i <= 120; i++) CAM.push(punta(i / 120));   // camino real de la punta
  let agarre = false, ini = null, movio = false;
  zona.addEventListener('pointerdown', e => { agarre = true; movio = false; ini = S.punto(e); S.el.classList.add('is-tocado'); try { zona.setPointerCapture(e.pointerId); } catch (x) {} });
  zona.addEventListener('pointermove', e => {
    if (!agarre) return;
    const p = S.punto(e);
    if (!movio && Math.hypot(p.x - ini.x, p.y - ini.y) < 12 / Math.max(S.k, 0.05)) return;
    movio = true;
    // la punta sigue al dedo por su camino real; se busca cerca de donde va (el camino se devuelve sobre sí mismo)
    const j0 = Math.round(meta * 120);
    let mj = j0, md = 1e9;
    for (let j = Math.max(0, j0 - 16); j <= Math.min(120, j0 + 16); j++) { const q = CAM[j], dd = (q[0] - p.x) ** 2 + (q[1] - p.y) ** 2; if (dd < md) { md = dd; mj = j; } }
    irA(mj / 120);
  });
  const soltar = () => {
    if (!agarre) return; agarre = false;
    if (!movio) { irA(k < 0.5 ? 1 : 0, 2200); return; }     // un toque (sin arrastrar) lo abre o lo recoge
    if (meta > 0.9) irA(1); else if (meta < 0.1) irA(0);
  };
  zona.addEventListener('pointerup', soltar); zona.addEventListener('pointercancel', () => { agarre = false; });
  zona.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); irA(k < 0.5 ? 1 : 0, 2200); } });

  pintar(); guia();
  window.addEventListener('resize', pintar);
});
